import { render, staticRenderFns } from "./TaskDialog.vue?vue&type=template&id=60861866"
import script from "./TaskDialog.vue?vue&type=script&lang=js"
export * from "./TaskDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskDialog.vue?vue&type=style&index=0&id=60861866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports